module.exports = __webpack_public_path__ + "static/img/weibo.a2173a8a.svg";